<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-26 12:00:00
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-30 11:56:35
 * @Description: 知产专利页面
-->
<template>
  <div class="patents-page bg-slate-50 min-h-screen">
    <!-- Header/Banner -->
    <div
      class="patents-header relative py-180px text-center bg-white lt-sm:py-160px overflow-hidden bg-cover bg-center bg-no-repeat"
    >
      <div class="landing-container relative z-10 flex-center flex-col">
        <h1 class="font-s-48px text-black pf-sc-semibold lt-sm:font-s-56px tracking-tight">
          荣誉资质
        </h1>
        <p
          class="font-s-18px mt-16px text-main/70 pf-sc-regular lt-sm:mt-12px lt-sm:font-s-26px max-w-800px mx-auto leading-relaxed"
        >
          绘家科技深耕智慧物业领域，凭借领先的技术实力和优质的服务，获得多项行业荣誉与认证
        </p>
      </div>
    </div>

    <IndustryTimeline />
    <PatentRow />
    <CopyrightsCarousel />

    <section-cta />
  </div>
</template>

<script setup lang="ts">
  import IndustryTimeline from './components/industry-timeline.vue'
  import PatentRow from './components/patent-row.vue'
  import CopyrightsCarousel from './components/copyrights-carousel.vue'

  const { openConsultation } = useConsultation()

  useSeoMeta({
    title: '荣誉资质 - 绘家科技',
    description:
      '绘家科技拥有5+项专利技术、13项行业荣誉认证、35+项软件著作权，坚持自主创新，构建智慧社区核心技术壁垒。',
    keywords: '绘家科技专利,智慧社区专利,软件著作权,技术实力,自主创新',
    ogTitle: '荣誉资质 - 绘家科技',
    ogDescription:
      '绘家科技拥有5+项专利技术、13项行业荣誉认证、35+项软件著作权，坚持自主创新，构建智慧社区核心技术壁垒。',
    ogImage: '/logo.png',
  })
</script>

<style scoped>
  .patents-header {
    background-image: url('@/assets/images/solution-cases-bg.jpg');
  }
</style>
